// Header.js
import React from 'react';

const Header = () => {
  return (
    <div>
      <p className="team-head team-head-text">Meet Our Team</p>
      <p className="team-sub-head">
        Just take a look - each member of the team is watching your every gesture and will hear your every whisper.
      </p>
    </div>
  );
}

export default Header;